import React, { Component } from "react";
import FlexView from "react-flexview";
import ModalContainer from "../../../../modules/commons/ModalContainer";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import SimpleDate from "../../../../modules/SimpleDate";
import SimpleDDL from "../../../../modules/SimpleDDL";
import SimpleInput from "../../../../modules/SimpleInput";
import { cashPlanOptions, indentDepositOptions } from "../config";
import Api from "../../../../Services/Api";
import { mapToObjectDDL } from "../../../common/mapper";

class IndentUnitBelumProsesFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      varianOptions: [],
      warnaOptions: [],
    };
  }

  async componentDidMount() {
    const responses = await Promise.all([
      Api.create("NAGAMAS_MASTER_DATA").getAllVariant(),
      Api.create("NAGAMAS_MASTER_DATA").getAllWarna(),
    ]);
    responses.forEach((r, idx) => {
      if (r.ok) {
        if (idx === 0) {
          this.setState((prevValue) => ({
            ...prevValue,
            varianOptions: r.data.data.map((d) => mapToObjectDDL(d.namaVariant, d.namaVariant)),
          }));
        } else {
          this.setState((prevValue) => ({
            ...prevValue,
            warnaOptions: r.data.data.map((d) => mapToObjectDDL(d.namaWarnaPabrik, d.namaWarnaPabrik)),
          }));
        }
      }
    });
  }

  handleValueChange = (name, value) => {
    this.props.onSetState((prevValue) => ({
      ...prevValue,
      filterData: {
        ...prevValue.filterData,
         [name]: typeof value === 'string'? value.toUpperCase() : value,
      },
    }));
  };

  handleClearFilter = () => {
    this.props.onSetState((prevValue) => ({
      ...prevValue,
      filterData: {},
    }));
  };

  getFilterDataValue = (fieldName, fallbackValue = "") => {
    return this.props.state.filterData?.[fieldName] ?? fallbackValue;
  };

  render() {
    return (
      <SimpleModal
        title="Filter Search"
        visible={this.props.visible}
        onClickClose={this.props.onClickClose}
        content={
          <ModalContainer>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                this.props.onSubmit();
                this.props.onClickClose();
              }}
            >
              <SimpleInput
                id="input_text_no_indent"
                name="indentNo"
                label="No. Indent"
                value={this.getFilterDataValue("indentNo")}
                onChange={({ target }) => this.handleValueChange(target.name, target.value)}
              />
              <FlexView column vAlignContent="center">
                <div className="txt-site txt-11 txt-main txt-bold">
                  <h4>Tgl. Indent</h4>
                </div>
                <FlexView vAlignContent="center" style={{ gap: "10px" }}>
                  <SimpleDate
                    id="select_date_start_tgl_indent"
                    name="startIndentDate"
                    nextdate
                    date={this.getFilterDataValue("startIndentDate", null)}
                    maxDate={this.getFilterDataValue("endIndentDate", null)}
                    onChange={(value) => this.handleValueChange("startIndentDate", value)}
                  />
                  <span className="margin-bottom-20px">s/d</span>
                  <SimpleDate
                    id="select_date_end_tgl_indent"
                    name="endIndentDate"
                    nextdate
                    date={this.getFilterDataValue("endIndentDate", null)}
                    onChange={(value) => this.handleValueChange("endIndentDate", value)}
                  />
                </FlexView>
              </FlexView>
              <SimpleInput
                id="input_text_nama_konsumen"
                name="customerName"
                label="Nama Konsumen"
                value={this.getFilterDataValue("customerName")}
                onChange={({ target }) => this.handleValueChange(target.name, target.value)}
              />
              <SimpleInput
                id="input_text_nik_ktp"
                name="customerKtpNumber"
                label="NIK KTP"
                box="onlyNumber"
                maxLength={16}
                value={this.getFilterDataValue("customerKtpNumber")}
                onChange={({ target }) => this.handleValueChange(target.name, target.value)}
              />
              <SimpleDDL
                id="select_options_varian"
                box="search"
                name="namaVariant"
                label="Varian"
                isClearable
                options={this.state.varianOptions}
                value={this.getFilterDataValue("namaVariant", null)}
                onChange={(value, { name }) => this.handleValueChange(name, value)}
              />
              <SimpleDDL
                id="select_options_wanra"
                box="search"
                name="namaWarna"
                label="Warna"
                isClearable
                options={this.state.warnaOptions}
                value={this.getFilterDataValue("namaWarna", null)}
                onChange={(value, { name }) => this.handleValueChange(name, value)}
              />
              <SimpleInput
                id="input_text_umur"
                box="onlyNumber"
                name="ageIndentUnit"
                label="Umur (hari)"
                maxLength={3}
                value={this.getFilterDataValue("ageIndentUnit")}
                onChange={({ target }) => this.handleValueChange(target.name, target.value)}
              />
              <SimpleDDL
                id="select_options_tanda_jadi"
                box="search"
                name="indentDeposit"
                label="Tanda Jadi"
                isClearable
                options={indentDepositOptions}
                value={this.getFilterDataValue("indentDeposit", null)}
                onChange={(value, { name }) => this.handleValueChange(name, value)}
              />
              <SimpleDDL
                id="select_options_rencana"
                box="search"
                name="paymentPlan"
                label="Rencana Pembayaran"
                isClearable
                value={this.getFilterDataValue("paymentPlan", null)}
                options={cashPlanOptions}
                onChange={(value, { name }) => this.handleValueChange(name, value)}
              />
              <FlexView hAlignContent="right">
                <SimpleButton secondary type="button" onClick={this.handleClearFilter}>
                  Clear
                </SimpleButton>
                <SimpleButton type="submit">Terapkan</SimpleButton>
              </FlexView>
            </form>
          </ModalContainer>
        }
      />
    );
  }
}

export default IndentUnitBelumProsesFilter;
